<script setup lang="ts">
import { redirectMethod } from '@/utils';
import { useRouter } from 'vue-router';
import { LazyImg, Waterfall } from 'vue-waterfall-plugin-next'
import 'vue-waterfall-plugin-next/dist/style.css'
const router = useRouter()
const testFn = () =>{
  redirectMethod(()=>{
    router.replace('/integral')
  })
}
</script>

<template>
  <div class="layout">
    123123
    <button @click="testFn">点击测试</button>
  </div>
</template>

<style lang="scss" scoped>
.layout{
  min-height:100vh;
}
.waterfall-list{
  background-color:transparent;
}
.cell-item {
    width: 100%;
    // margin-bottom: 18px;
    background: #ffffff;
    padding: 8px 8px 0 8px;
    border-radius: 12px 12px 12px 12px;
    overflow: hidden;
    box-sizing: border-box;
    /* margin-bottom: 10px; */
    img {
      // border-radius: 12px 12px 0 0;
      width: 154px;
      height: 154px;
      display: block;
      border-radius: 10px;
      object-fit: contain;
    }
    .item-body {
      // border: 1px solid #F0F0F0;
      padding: 12px 0;
      .item-title {
        position: relative;
        font-size: 14px;
        color: #333333;
        line-height: 15px;
        font-weight: bold;
        line-height: 1.6;
        overflow: hidden;
        text-overflow: ellipsis;
        /* 将对象作为弹性伸缩盒子模型显示 */
        display: -webkit-box;
        /* 限制在一个块元素显示的文本的行数 */
        /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
        -webkit-line-clamp: 2;
        /* 设置或检索伸缩盒对象的子元素的排列方式 */
        -webkit-box-orient: vertical;
        .tag {
          display: inline-block;
          padding: 3px 4px;
          font-size: 8px;
          border-radius: 4px;
          bottom: 3px;
          background: linear-gradient(
            111deg,
            #fff853 4.98%,
            #6eef94 56.05%,
            #2ad8cd 95.37%
          );
        }
      }
      .address{
        font-size: 12px;
        color: #9C9CAA;
        line-height: 1.6;
      }
      .price{
        font-size: 12px;
        color: #FF3456;
        font-weight: 700;
        margin-top: 8px;
        .number-font{
          font-size: 18px;
        }
        .text{
          color: #000;
        }
      }
    }
  }
</style>
